import { IMAGES } from "../data";
import { ShieldCheck, Clock, Sprout, Award } from "lucide-react";

const stats = [
  { value: "15+", label: "Years of Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "100%", label: "Satisfaction Focused" },
];

const points = [
  { icon: ShieldCheck, title: "Licensed & Insured", desc: "Professional, reliable crews you can trust on your property." },
  { icon: Sprout, title: "Local Expertise", desc: "Plants and designs suited to Georgia's climate and soil." },
  { icon: Clock, title: "On-Time, Every Time", desc: "Dependable scheduling and clear communication throughout." },
  { icon: Award, title: "Quality Craftsmanship", desc: "Attention to detail that elevates every outdoor space." },
];

export const WhyUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-24 md:py-32 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="overline">Why JMG Landscape</p>
          <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight leading-tight mt-4 text-[#1A2118]">
            Rooted in craft, grown through care
          </h2>
          <p className="text-[#4A5447] text-base md:text-lg font-light mt-6 leading-relaxed max-w-lg">
            From the first sketch to the final trim, we treat every yard as if it
            were our own. Our team blends horticultural knowledge with precise
            craftsmanship to create landscapes that thrive year after year.
          </p>

          <div className="grid sm:grid-cols-2 gap-6 mt-10">
            {points.map((p) => {
              const Icon = p.icon;
              return (
                <div key={p.title} data-testid={`why-point-${p.title.toLowerCase().split(" ")[0]}`} className="flex gap-4">
                  <div className="shrink-0 w-11 h-11 rounded-sm bg-[#1E3F20]/8 flex items-center justify-center">
                    <Icon size={20} strokeWidth={1.5} className="text-[#1E3F20]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1A2118]">{p.title}</h3>
                    <p className="text-sm text-[#4A5447] font-light mt-1 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex gap-10 mt-12 border-t border-[#D8D3C8] pt-8">
            {stats.map((s) => (
              <div key={s.label}>
                <div className="font-serif-display text-4xl text-[#1E3F20]">{s.value}</div>
                <div className="text-xs uppercase tracking-wider text-[#4A5447] mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <img
            src={IMAGES.whyUs}
            alt="Beautifully maintained backyard landscape"
            className="w-full h-[460px] lg:h-[600px] object-cover rounded-sm border border-[#D8D3C8]"
          />
          <div
            data-testid="testimonial-block"
            className="absolute -bottom-6 -left-4 sm:left-8 max-w-xs bg-[#F7F5F0] border border-[#D8D3C8] rounded-sm p-6 shadow-sm"
          >
            <p className="font-serif-display text-xl italic text-[#1A2118] leading-snug">
              "Our yard has never looked better. Truly the best in the area."
            </p>
            <p className="text-xs uppercase tracking-wider text-[#4A5447] mt-3">— Homeowner, Dallas GA</p>
          </div>
        </div>
      </div>
    </section>
  );
};
